import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomToneOfVoice,
  BackendMutationExtractCustomToneOfVoiceArgs,
} from 'src/types/backend';

import { FRAGMENT_CUSTOM_TONE_OF_VOICE } from './schema';

const MUTATION = gql`
  mutation ExtractCustomToneOfVoice(
    $brandVoiceId: ID!
    $url: String
    $text: String
    $resourceId: ID
    $inputType: TovExtractionInputTypeEnum
  ) {
    extractCustomToneOfVoice(
      brandVoiceId: $brandVoiceId
      url: $url
      text: $text
      resourceId: $resourceId
      inputType: $inputType
    ) {
      ...CustomToneOfVoice
    }
  }
  ${FRAGMENT_CUSTOM_TONE_OF_VOICE}
`;

type Variables = BackendMutationExtractCustomToneOfVoiceArgs;
type Result = BackendCustomToneOfVoice;

export const extractCustomToneOfVoice = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
